import { ISelectOption } from 'components/forms/Selects'
import { ICertificationCode } from 'types/FMSGraphqlTypes'

interface IGetCertificationOptionsProps {
  isEditing: boolean
  certificationTitleOptions: ISelectOption<ICertificationCode>[]
  existingCertificationCodes: ICertificationCode[]
}

export const getCertificationOptions = ({
  certificationTitleOptions,
  existingCertificationCodes,
  isEditing,
}: IGetCertificationOptionsProps): ISelectOption<ICertificationCode>[] => {
  if (isEditing) {
    return certificationTitleOptions
  }
  // filter out certifications that have already been added
  return certificationTitleOptions.filter(
    ({ value }) => !existingCertificationCodes.includes(value)
  )
}
